import { withStyles, makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import bg from "../../assets/images/bg_small.jpg";
import bgDarkPurple from "../../assets/images/bg_small_purple.png";

export const WhiteSkeleton = withStyles((theme) => ({
  root: {
    backgroundColor: "rgba(255, 255, 255, 0.11)",
  },
}))(Skeleton);

export const useStyles = makeStyles((theme) => ({
  gridContainer: {
    backgroundImage: `url(${bgDarkPurple})`,
    backgroundBlendMode: "initial",
    minHeight: "35.31rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      minHeight: "25rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      minHeight: "31.25rem",
    },
  },
  grid1: {
    position: "relative",
    order: 1,
    paddingTop: "120%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      paddingTop: "55%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      paddingTop: "49%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      paddingTop: "40%",
    },
  },
  center_grid1: {
    position: "relative",
    order: 1,
  },
  grid2: {
    order: 2,
  },
  hero_bg: {
    position: "absolute",
    display: "block",
    top: "calc(50% - 40%)",
    left: "calc(50% - 35%)",
    width: "70%",
    height: "80%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      top: "calc(50% - 35%)",
      left: "calc(50% - 30%)",
      width: "60%",
      height: "70%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      top: "calc(50% - 37.5%)",
      left: "calc(50% - 25%)",
      width: "50%",
      height: "75%",
    },
  },
  hero_data: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "91.2%",
    margin: "0 auto 3.75rem auto",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "87.5%",
      margin: "15% 0 0 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "69.48%",
      margin: "21.5% 0 0 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      width: "72%",
      margin: "16.4% 0 0 0",
    },
  },
  hero_heading: {
    width: "100%",
    height: "3.75rem",
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: "0 0 1rem 0",
    },
  },
  hero_text: {
    margin: "0 0 1rem 0",
    width: "100%",
    height: "8.125rem",
  },
  center_button: {
    width: "10rem",
    height: "4.375rem",
  },
  freeText_heading: {
    width: "30%",
    height: "3.75rem",
    marginLeft: "calc(50% - 15%)",
    marginBottom: "1rem",
  },
  freeText_textLine: {
    width: "92%",
    height: "1.875rem",
    marginLeft: "calc(50% - 46%)",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "44rem",
      marginLeft: "calc(50% - 22rem)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "49.25rem",
      marginLeft: "calc(50% - 24.625rem)",
    },
  },
  freeText_button: {
    margin: "1rem 0",
    width: "10rem",
    height: "4.375rem",
    marginLeft: "calc(50% - 5rem)",
  },
  takisGridItemContainer: {
    marginBottom: "2rem",
    position: "relative",
  },
  grid_item: {
    width: "60%",
    marginLeft: "calc(50% - 30%)",
    height: "31.25rem",
  },
  takisGrid: {
    position: "relative",
    backgroundImage: `linear-gradient(to top, ${theme.palette.gridPurple} 0%, ${theme.palette.gridPurple} 100%), url(${bg})`,
    backgroundBlendMode: "multiply",
    padding: "2.5rem 0 0.5rem",
    "&:before": {
      width: "100%",
      height: "1rem",
      content: '""',
      position: "absolute",
      clipPath: "polygon(0% 0%, 0% 100%, 100% 0%)",
      backgroundSize: "cover",
      backgroundColor: theme.palette.yellow,
      top: "-0.063rem",
    },
  },
  gridDividerMargin: {
    height: "6.5rem",
  },
  freeText: {
    backgroundColor: theme.palette.yellow,
    padding: "2.5rem 0",
  },
  slide_footer: {
    display: "flex",
    width: "100%",
    backgroundImage: `url(${bgDarkPurple})`,
    backgroundBlendMode: "initial",
  },
  hero_divider_margin: {
    height: "2rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "4rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "3rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      height: "4rem",
    },
  },
  productDetailHero: {
    backgroundColor: theme.palette.yellow,
    position: "relative",
    display: "flex",
    paddingBottom: "2rem",
    height: "62.25rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "74.688rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "46.188rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      height: "58.375rem",
    },
  },
  backgroundContainer: {
    backgroundColor: theme.palette.darkPurple,
    position: "absolute",
    width: "100%",
    height: "calc(30% + 3rem)",
    "&::after": {
      left: "0",
      right: "0",
      bottom: "-1.5rem",
      height: "4rem",
      content: '""',
      position: "absolute",
      transform: "skewY(-3deg)",
      background: "#f8df10",
      [theme.breakpoints.up("md")]: {
        transform: "skewY(-2deg)",
        bottom: "-2.063rem",
      },
    },
    [theme.breakpoints.up("md")]: {
      height: "calc(24% + 3rem)",
    },
    [theme.breakpoints.up("lg")]: {
      height: "calc(38% + 4rem)",
    },
    [theme.breakpoints.up("xl")]: {
      height: "calc(38% + 4rem)",
    },
  },
  productDetailContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 auto",
    marginTop: "1.063rem",
    maxWidth: "21.375rem",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      marginTop: "1.188rem",
      maxWidth: "32.5rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      marginTop: "14.563rem",
      maxWidth: "22.625rem",
      alignItems: "unset",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      marginTop: "17.25rem",
      maxWidth: "25.75rem",
      alignItems: "unset",
    },
  },
  productHeroImage: {
    display: "inline-block",
    width: "18rem",
    height: "24.563rem",
    margin: "2.5rem 0 0 calc(50% - 9rem)",
    border: "solid 0.063rem",
    borderColor: "rgba(255, 255, 255, 0.22)",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "25rem",
      height: "34.375rem",
      margin: "3.125rem 0 0 calc(50% - 12.5rem)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "22rem",
      height: "30rem",
      marginTop: "3.125rem",
      marginLeft: "calc(50% - 11rem)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      width: "30rem",
      height: "42rem",
      marginTop: "3rem",
      marginLeft: "calc(50% - 15rem)",
    },
  },
  product_hero_heading: {
    width: "60%",
    height: "3.75rem",
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: "0 0 2rem 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      backgroundColor: "rgba(255, 255, 255, 0.11) !important",
      margin: "0 0 3.125rem 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      backgroundColor: "rgba(255, 255, 255, 0.11) !important",
      margin: "0 0 4.063rem 0",
    },
  },
  product_hero_text: {
    width: "100%",
    height: "13.5rem",
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: "0 0 2rem 0",
      height: "7.5rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      margin: "0 0 2rem 0",
      height: "13.5rem",
    },
  },
  product_hero_button: {
    width: "9.375rem",
    height: "4.375rem",
    margin: "0 0 1.5rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      margin: "0 0 2rem calc(50% - 4.688rem)",
    },
  },
  product_hero_decoration: {
    width: "23.375rem",
    height: "7.5rem",
    margin: "0 0 1rem 0",
    marginLeft: "calc(50% - 11.688rem)",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "44rem",
      height: "14rem",
      marginLeft: "calc(50% - 22rem)",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      display: "none",
    },
  },
  social_container: {
    width: "100%",
    height: "auto",
    margin: "0 auto",
    backgroundColor: theme.palette.yellow,
    padding: "4.5rem 0",
  },
  social_heading: {
    width: "15.625rem",
    marginLeft: "calc(50% - 7.813rem)",
    height: "3.438rem",
    margin: "0 0 1.75rem 0",
  },
  left_container_bg: {
    position: "relative",
    display: "flex",
    height: "20rem",
    width: "100%",
    maxWidth: "32.5rem",
    margin: "0 auto 1rem auto",
    clipPath: "polygon(0 0%, 0% 100%, 101% 100%, 101% 10%)",
    backgroundSize: "cover",
    backgroundColor: theme.palette.purple,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "unset",
      width: "32.5rem",
      height: "25rem",
      margin: "0 0 1rem 12%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "100%",
      margin: "0",
    },
  },
  left_container: {
    position: "relative",
    height: "calc(100% - 2rem)",
    width: "calc(100% - 2rem)",
    margin: "1rem 0 0 1rem",
    clipPath: "polygon(0 0%, 0% 100%, 101% 100%, 101% 10%)",
    backgroundSize: "cover",
  },
  right_container: {
    position: "relative",
    height: "20rem",
    width: "100%",
    maxWidth: "32.5rem",
    margin: "0 auto",
    clipPath: "polygon(0 0%, 0% 95%, 100% 100%, 100% 0%)",
    backgroundColor: theme.palette.purple,
    backgroundImage: `url(${bg})`,
    backgroundBlendMode: "multiply",
    backgroundSize: "cover",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "unset",
      clipPath: "polygon(0 0%, 0% 92%, 100% 100%, 100% 0%)",
      width: "32.5rem",
      height: "25rem",
      margin: "0 12% 0 0",
      float: "right",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "100%",
      margin: "0",
    },
  },
  icon_container: {
    display: "none",
    position: "absolute",
    top: "0.625rem",
    right: "0.625rem",
    width: "3.25rem",
    height: "3.25rem",
    backgroundColor: theme.palette.purple,
    borderRadius: "15%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: "unset",
    },
  },
  unset_icon: {
    display: "unset",
    position: "relative",
    top: "unset",
    left: "unset",
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      display: "none",
    },
  },
  social_details_container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "2.5% 0 0 4.3%",
    width: "41%",
    height: "64%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      width: "41%",
      height: "100%",
      margin: "0 0 0 3.1%",
      minWidth: "13.375rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      width: "42%",
    },
  },
  social_details_heading: {
    width: "12.5rem",
    height: 50,
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      margin: "0 0 0.625rem 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      margin: "0 0 0.625rem 0",
    },
  },
  social_details_p: {
    width: "100%",
    height: "5.313rem",
    margin: "0 0 1rem 0",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "7.5rem",
      margin: "0 0 1.5rem 0",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      margin: "0 0 1rem 0",
    },
  },
  social_image: {
    height: "12.938rem",
    width: "9.125rem",
    margin: "0.625rem 0 0 14.2%",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "78%",
      width: "13.813rem",
      margin: "7.5% 0 0 10.5%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      height: "76.6%",
      width: "13.813rem",
      margin: "6% 0 0 9%",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
      height: "90%",
      width: "16.188rem",
      margin: "2% 0 0 10%",
    },
  },
  button_container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  social_button: {
    width: "7.5rem",
    height: "3.75rem",
  },
  right_content: {
    display: "flex",
    width: "100%",
    height: "auto",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: "100%",
    },
  },
  recipeDetailHero: {
    backgroundColor: theme.palette.purple,
    position: "relative",
    paddingBottom: "2.5rem",
  },
  recipeDetailHeroImage: {
    transform: "none",
    width: "100%",
    height: "40rem",
  },
  recipeDetailHeroDivider: {
    position: "absolute",
    bottom: "0",
    width: "100%",
  },
  recipeDetailHeroDividerMargin: {
    height: "2rem",
    [theme.breakpoints.up("md")]: {
      height: "2.5rem",
    },
  },
  recipeDetailContent: {
    backgroundColor: theme.palette.yellow,
  },
  recipeDetailText: {
    height: "auto",
    paddingBottom: "2.5rem",
    margin: "0 auto",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "21.4rem",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "45rem",
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "53.5rem",
    },
  },
  recipeDetailParagraph: {
    transform: "none",
  },
  takisRecipeList: {
    backgroundColor: theme.palette.yellow,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "8rem",
  },
  takisRecipeHeading: {
    width: "15rem",
    height: "3.7rem",
    margin: "0 auto 1rem",
  },
  takisRecipeButton: {
    width: "10rem",
    height: "3.7rem",
    margin: "0 auto 1rem",
  },
  takisRecipeListItemContainer: {
    [theme.breakpoints.up("sm")]: {
      width: "21.375rem",
      height: "24.125rem",
    },
    [theme.breakpoints.up("md")]: {
      width: "32.5rem",
    },
    [theme.breakpoints.up("lg")]: {
      width: "28.75rem",
    },
    [theme.breakpoints.up("xl")]: {
      width: "36.56rem",
    },
  },
  takisRecipeListItem: {
    width: "100%",
    height: "100%",
    transform: "none",
  },
  takisRecipeListContainer: {
    [theme.breakpoints.up("sm")]: {
      maxWidth: "2rem",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: "33rem",
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "60rem",
    },
    [theme.breakpoints.up("xl")]: {
      maxWidth: "82rem",
    },
  },
}));
